import { Button, Panel, Tabs } from '@sketchnote/shared-components';
import React, { useEffect } from 'react';
import { API, endpoints } from 'src/api';
const { useState, useCallback } = React;
import cn from 'classnames';
import { Picker } from 'emoji-mart';

import { emojiPopoverService } from './EmojiPopoverService';

type recentImg = {
  src: string;
};

export interface handleUpdateFieldsProps {
  name?: string;
  icon?: { id?: any; type?: string };
  description?: string;
}

export interface EmojiPopoverProps {
  onChangeIcon: (handleUpdateFieldsProps) => void;
}

export const EmojiPopover = ({ onChangeIcon }: EmojiPopoverProps) => {
  const [recentIconUploads, setRecentIconUploads] = useState<recentImg[]>([]);
  const hiddenFileInput = React.useRef<any>(null);
  const imgUrlRef = React.useRef<any>(null);
  const { getRecentIcons, updateRecentIcon } = emojiPopoverService();
  const handleChooseImg = useCallback(() => {
    hiddenFileInput.current.click();
  }, []);

  useEffect(() => {
    handleRecentIcons();
  }, []);

  const handleFileUpload = async (file) => {
    const data = new FormData();
    data.append('file', file);
    const response = await API.post(endpoints.creationFile.url, data, {
      headers: { ['Content-Type']: 'multipart/form-data' },
    });

    return response.data?.data?.message?.url;
  };

  const onFileChange = useCallback(async (event) => {
    if (event.target.files.length) {
      const imgUrl = await handleFileUpload(event.target.files[0]);
      onChangeIcon({ icon: { id: imgUrl, type: 'image' } });
      await updateRecentIcon(imgUrl);
    }
  }, []);

  const handleRecentIcons = async () => {
    const images: recentImg[] = await getRecentIcons();
    setRecentIconUploads(images);
  };

  const handleLink = async (e) => {
    onChangeIcon({ icon: { id: imgUrlRef.current.value, type: 'image' } });
  };

  return (
    <div
      style={{ maxHeight: '50vh' }}
      className="flex overflow-auto flex-col p-16 rounded-lg bg-white shadow-sm text-gray-999 w-368 relative"
    >
      <Tabs selected={0} size="small" className="border-b font-regular text-xs items-center">
        <Panel title="Gallery">
          <div className="my-16">
            <Picker
              title="Pick your emoji…"
              emoji="point_up"
              sheetSize={32}
              perLine={9}
              showPreview={false}
              showSkinTones={false}
              onSelect={(e) => onChangeIcon({ icon: { id: e.id } })}
            />
          </div>
        </Panel>
        <Panel title="Upload">
          <div className="mt-16">
            <Button
              status="primary"
              className="mb-8 w-full justify-center px-15"
              size="sm"
              onClick={handleChooseImg}
            >
              Choose image
            </Button>
            <input
              ref={hiddenFileInput}
              accept="image/*"
              className="hidden"
              id="file"
              multiple={false}
              type="file"
              onChange={onFileChange}
            />
            <div className="text-sm font-regular text-gray-600 mb-26">
              Recommended size is 280 x 280 pixels
            </div>
            <div className="text-lg font-regular text-gray-600 my-10 mb-14">Recent uploads</div>
            <div className="mt-16">
              {recentIconUploads &&
                recentIconUploads.length > 0 &&
                recentIconUploads.map((image, index) => (
                  <button
                    className={cn('w-78 h-54', {
                      'mr-8 mb-8': (index + 1) % 4 !== 0,
                    })}
                    onClick={() => {
                      onChangeIcon({ icon: { id: image.src, type: 'image' } });
                    }}
                    key={`${image}-${index}`}
                  >
                    <img
                      src={image.src}
                      loading="lazy"
                      className="w-full h-full object-center object-cover rounded-md"
                    />
                  </button>
                ))}
            </div>
          </div>
        </Panel>
        <Panel title="Link">
          <div className="mt-16">
            <div className="py-14 bg-gray-200 rounded-sm h-48 w-full px-12">
              <input
                placeholder="http://"
                className=" bg-gray-200 text-gray-500 font-regular placeholder-gray-500 w-full"
                ref={imgUrlRef}
              />
            </div>
            <Button status="primary" className="mt-16 float-right" size="sm" onClick={handleLink}>
              Embed image
            </Button>
          </div>
        </Panel>
      </Tabs>
      <button
        className="absolute rounded-md right-20 px-6 py-3 hover:bg-gray-100 font-regular text-sm items-center text-gray-500"
        onClick={() => onChangeIcon({ icon: { id: '', type: '' } })}
      >
        Remove
      </button>
    </div>
  );
};
